module.exports = __webpack_public_path__ + "img/about-hero-2.9499e7c1.svg";